import { makeStyles } from '@material-ui/styles';
// import tinycolor from 'tinycolor2';

export default makeStyles(theme => ({
    st0: {
        fill: 'url(#SVGID_1_)',
    },

    st1: {
        fill: '#A324AD',
    },

    st2: {
        fill: '#100239',
    },

    st11: {
        fill: 'none',
    },

    st12: {
        fill: '#FFFFFF',
    },

    st13: {
        fontFamily: 'Roboto, sans-serif',
        // fontFamily: 'Open Sans, sans-serif',
    },

    st14: {
        fontSize: '15px',
        // fontWeight: '600',
    },

}));
